export default __webpack_public_path__ + "static/media/mastercard.1111be29.svg";